import { useLocation } from 'react-router';
import { useProStudioRoutes } from '.';

export const useCurrentRoute = (): {
  route: string;
  label: string | null;
} => {
  const { pathname } = useLocation();
  const routes = useProStudioRoutes();

  const currentRoute = Object.entries(routes).find(
    ([_, route]) => route.path === pathname
  );

  const currentRouteLabel = currentRoute?.[1]?.label || null;

  return {
    route: currentRoute?.[0] || 'home',
    label: currentRouteLabel,
  };
};
